import { useDispatch, useSelector } from "react-redux";
import { Grid, TextField } from "@material-ui/core";
import { useForm } from "hooks/useForm";
import React, { useEffect } from "react";
import { initialValues, valuesRequired } from "./initialValues";
import { tankTypeDictionary } from "helpers/dictionary";
import { PERMISSIONS } from "router/permissions";
import RegularButton from "components/CustomButtons/Button";
import { createNewTank, editTank } from "redux/actions/tanks/tanksAction";
import { Autocomplete } from "@material-ui/lab";

export const TankForm = ({ tank, onClose, isEdit = false }) => {
    const dispatch = useDispatch();
    const { rules } = useSelector(({ login }) => login);
    const { companiesList, stationsList} = useSelector(({ companies }) => companies);
    const { unitsMap } = useSelector(({ unitsReducer }) => unitsReducer);
    const { company: companyFilter } = useSelector(({ tanks2 }) => tanks2)

    const {
        inputValues,
        fieldErrors,
        handleInputOnChange,
        handleNewValues: setValues,
        runValidates
    } = useForm(initialValues, valuesRequired(isEdit));
    const {
        company,
        station,
        unit,
        name,
        latitude,
        longitude,
        capacity,
        type,
        deviceId,
        uuidAws
    } = inputValues;

    const handleSubmit = e => {
        e.preventDefault();
        if (runValidates()) return;
        const form = {
            name,
            latitude: parseFloat(latitude),
            longitude: parseFloat(longitude),
            capacity: parseInt(capacity),
            type: type.value,
            idUnit: unit?.id,
            uuidAws,
            deviceId,
        };
        !isEdit
            ? dispatch(createNewTank(form, station.id,  onClose))
            : dispatch(editTank(tank.id, form, onClose))
    };

    useEffect(() => {
        if(isEdit){
            const stationValue = stationsList.find(stationL => stationL.id === tank?.id_station)
            setValues({
                company: companiesList.find(company => company.id === stationValue?.id_company) ,
                station: stationValue,
                unit: unitsMap.find(unit => unit.id === tank.id_unit),
                name: tank?.name,
                latitude: tank?.latitude,
                longitude: tank?.longitude,
                capacity: tank?.capacity,
                type: tankTypeDictionary.find(type => type.value === tank.type),
                deviceId: tank?.device_id,
                uuidAws: tank?.uuid_aws
            });
        } 
        !isEdit && setValues({ company: companyFilter, })
    }, []);

    return (
        <form onSubmit={e => handleSubmit(e)} style={{ maxWidth: 500 }}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <Autocomplete
                        id="tanks-company-section"
                        options={companiesList || []}
                        value={company}
                        getOptionLabel={option => option?.label}
                        renderInput={params => (
                            <TextField
                                {...params}
                                // name="idUnit"
                                label="Empresa"
                                variant="outlined"
                                error={fieldErrors.company}
                                helperText={fieldErrors.company || ""}
                            />
                        )}
                        fullWidth
                        onChange={(e, v) => setValues({
                            company: v,
                            station: v?.stations || null
                        })}
                        noOptionsText="No se encuentra la Empresa"
                        disabled={isEdit}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Autocomplete
                        id="tanks-station-section"
                        options={company?.stations || []}
                        value={station}
                        getOptionLabel={option => option?.label}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label="Planta"
                                variant="outlined"
                                error={fieldErrors.station}
                                helperText={fieldErrors.station || ""}
                            />
                        )}
                        fullWidth
                        onChange={(e, v) => setValues({ station: v })}
                        noOptionsText="No se encuentra la Planta"
                        disabled={isEdit}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Autocomplete
                        id="tanks-units-section"
                        options={unitsMap.filter(unit => unit.idStation === station?.id) || []}
                        value={unit}
                        getOptionLabel={option => option?.label}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label="Unidad"
                                variant="outlined"
                                error={fieldErrors.unit}
                                helperText={fieldErrors.unit || ""}
                            />
                        )}
                        fullWidth
                        onChange={(e, v) => setValues({ unit: v })}
                        noOptionsText="No se encuentra la Unidad"
                        disabled={isEdit}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        label="Nombre"
                        name="name"
                        value={name}
                        variant="outlined"
                        onChange={handleInputOnChange}
                        fullWidth
                        error={fieldErrors.name}
                        helperText={fieldErrors.name || ""}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        label="Latitud"
                        name="latitude"
                        value={latitude}
                        variant="outlined"
                        type="number"
                        onChange={handleInputOnChange}
                        fullWidth
                        error={fieldErrors.latitude}
                        helperText={fieldErrors.latitude || ""}
                        inputProps={{
                            right: "1"
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        label="Longitud"
                        name="longitude"
                        value={longitude}
                        variant="outlined"
                        type="number"
                        onChange={handleInputOnChange}
                        fullWidth
                        error={fieldErrors.longitude}
                        helperText={fieldErrors.longitude || ""}
                        inputProps={{
                            right: "1"
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        label="Capacidad"
                        name="capacity"
                        value={capacity}
                        variant="outlined"
                        type="number"
                        onChange={handleInputOnChange}
                        fullWidth
                        error={fieldErrors.capacity}
                        helperText={fieldErrors.capacity || ""}
                        inputProps={{
                            right: "1"
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Autocomplete
                        id="tanks-type-section"
                        options={tankTypeDictionary || []}
                        value={type}
                        getOptionLabel={option => option?.label}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label="Tipo"
                                variant="outlined"
                                error={fieldErrors.type}
                                helperText={fieldErrors.type || ""}
                            />
                        )}
                        fullWidth
                        onChange={(e, v) => setValues({ type: v })}
                        noOptionsText="No se encuentra el Tipo"
                    />
                </Grid>
                {rules.includes(PERMISSIONS.TANK_DEVICE_ID) && (
                    <Grid item xs={12} md={12}>
                        <TextField
                            label="Device ID"
                            name="deviceId"
                            value={deviceId}
                            variant="outlined"
                            onChange={handleInputOnChange}
                            fullWidth
                        />
                    </Grid>
                )}
                {rules.includes(PERMISSIONS.TANK_AWS_UUID) && (
                    <Grid item xs={12} md={12}>
                        <TextField
                            label="AWS ID"
                            name="uuidAws"
                            value={uuidAws}
                            variant="outlined"
                            onChange={handleInputOnChange}
                            fullWidth
                        />
                    </Grid>
                )}
            </Grid>
            <Grid
                item
                xs={12}
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 8,
                    marginTop: 16
                }}
            >
                <RegularButton color="transparent" onClick={onClose}>
                    cancelar
                </RegularButton>
                <RegularButton color="info" onClick={handleSubmit}>
                    {isEdit ? 'Editar' : 'Agregar'}
                </RegularButton>
            </Grid>
        </form>
    );
};